import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/axios'
import './plugins/element'
import './permission'
import './styles/emoji.css'

// 配置请求的根路径
// import Axios from  './plugins/axios'
// Axios.defaults.baseURL = '/api'
// Axios.defaults.headers.post['Content-Type'] = 'application/json'

// global registration OverlayScrollbars
import 'overlayscrollbars/css/OverlayScrollbars.css'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue'
Vue.component('overlay-scrollbars', OverlayScrollbarsComponent)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
